import { z } from 'zod';
import { MANAGEMENT_FEE_SETTLEMENT_BILL_STATUSES } from './managementFeeSettlements';

const managementFeeSettlementBillRowSchema = z.object({
  billId: z.string(),
  propertyId: z.string(),
  propertyName: z.string(),
  invoiceNumber: z.string().optional(),
  dueDate: z.string(),
  amountCents: z.number(),
  status: z.enum(MANAGEMENT_FEE_SETTLEMENT_BILL_STATUSES),
  detail: z.string().optional(),
});

/** POST /accounting/management-fee-settlements response. */
export const managementFeeSettlementReportSchema = z.object({
  operatingOrganizationId: z.string(),
  filterYyyyMm: z.string().nullable(),
  settlementDate: z.string(),
  billCount: z.number(),
  rows: z.array(managementFeeSettlementBillRowSchema),
  summary: z.object({
    successPaid: z.number(),
    skippedInsufficientCash: z.number(),
    skippedReserveViolation: z.number(),
    skippedAlreadyPaid: z.number(),
    errors: z.number(),
  }),
});
